/* eslint-disable*/
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import emailjs from "emailjs-com";

// Images
import macbook from "assets/images/macbook.png";
// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKInput from "components/MKInput";
import MKButton from "components/MKButton";
import MKTypography from "components/MKTypography";
import { useState } from "react";

// Images

function Newsletter() {
  const [formData, setFormData] = useState({
    nom: "",
    email: "",
    message: "",
    objet: "Message depuis ton portfolio",
    date: new Date().toLocaleString("fr-FR", {
      dateStyle: "short",
      timeStyle: "short"
    })
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    emailjs
      .send(
        "service_rakotozafy",   // depuis EmailJS
        "template_rakotozafy",  // depuis EmailJS
        formData,
        "vCrZV9HlSdcv2YMF7"     // depuis EmailJS
      )
      .then(
        (result) => {
          alert("Message envoyé avec succès !");
        },
        (error) => {
          alert("Erreur lors de l'envoi.");
        }
      );
  };
  return (
    <MKBox component="section" pt={6} my={6}>
      <Container>
        <Grid container alignItems="center">
          <Grid item  md={12} sx={{ ml: { xs: 0, lg: 3 }, mb: { xs: 12, md: 0 } }}>


            <MKBox component="section" py={{ xs: 0, lg: 6 }}>
              <Container>
                <Grid container item>
                  <MKBox
                    width="100%"
                    bgColor="white"
                    borderRadius="xl"
                    shadow="xl"
                    mb={6}
                    sx={{ overflow: "hidden" }}
                  >
                    <Grid container spacing={2}>
                      <Grid
                        item
                        xs={12}
                        lg={5}
                        position="relative"
                        px={0}
                        sx={{
                          backgroundImage: ({
                            palette: { gradients },
                            functions: { rgba, linearGradient },
                          }) =>
                            `${linearGradient(
                              rgba(gradients.dark.main, 0.8),
                              rgba(gradients.dark.state, 0.8)
                            )}, url(${macbook})`,
                          backgroundSize: "cover",
                        }}
                      >
                        <MKBox
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          width="100%"
                          height="100%"
                        >
                          <MKBox py={6} pr={6} pl={{ xs: 6, sm: 12 }} my="auto">
                            <MKTypography variant="h3" color="white" mb={1}>
                              Contact Information
                            </MKTypography>
                            <MKTypography variant="body2" color="white" opacity={0.8} mb={3}>
                              Remplissez le formulaire et je vous répondrai dans les 24 heures.
                            </MKTypography>
                            <MKBox display="flex" p={1}>
                              <MKTypography variant="button" color="white">
                                <i className="fas fa-phone" />
                              </MKTypography>
                              <MKTypography
                                component="span"
                                variant="button"
                                color="white"
                                opacity={0.8}
                                ml={2}
                                fontWeight="regular"
                              >
                                (+261) 38 52 470 39
                              </MKTypography>
                            </MKBox>
                            <MKBox display="flex" color="white" p={1}>
                              <MKTypography variant="button" color="white">
                                <i className="fas fa-envelope" />
                              </MKTypography>
                              <MKTypography
                                component="span"
                                variant="button"
                                color="white"
                                opacity={0.8}
                                ml={2}
                                fontWeight="regular"
                              >
                                tojotiana.rakotozafy@gmail.com
                              </MKTypography>
                            </MKBox>
                            <MKBox display="flex" color="white" p={1}>
                              <MKTypography variant="button" color="white">
                                <i className="fas fa-map-marker-alt" />
                              </MKTypography>
                              <MKTypography
                                component="span"
                                variant="button"
                                color="white"
                                opacity={0.8}
                                ml={2}
                                fontWeight="regular"
                              >
                                AVB 141 Avarabohitra , Antananarivo , Madagascar .
                              </MKTypography>
                            </MKBox>
                            <MKBox mt={3}>
                              <MKButton variant="text" color="white" size="large" iconOnly>
                                <i className="fab fa-facebook" style={{ fontSize: "1.25rem" }} />
                              </MKButton>
                              <MKButton variant="text" color="white" size="large" iconOnly>
                                <i className="fab fa-twitter" style={{ fontSize: "1.25rem" }} />
                              </MKButton>
                              <MKButton variant="text" color="white" size="large" iconOnly>
                                <i className="fab fa-dribbble" style={{ fontSize: "1.25rem" }} />
                              </MKButton>
                              <MKButton variant="text" color="white" size="large" iconOnly>
                                <i className="fab fa-instagram" style={{ fontSize: "1.25rem" }} />
                              </MKButton>
                            </MKBox>
                          </MKBox>
                        </MKBox>
                      </Grid>

                      <Grid item xs={12} lg={7}>
                        <MKBox component="form" p={2} method="post">
                          <MKBox px={3} py={{ xs: 2, sm: 6 }}>
                            <MKTypography variant="h2" mb={1}>
                              Faites-moi signe !
                            </MKTypography>
                            <MKTypography variant="body1" color="text" mb={2}>
                              Je serais heureux de parler avec vous.
                            </MKTypography>
                          </MKBox>
                          <MKBox pt={0.5} pb={3} px={3}>
                            <Grid container>
                              <Grid item xs={12} pr={1} mb={6}>
                                <MKInput
                                  variant="standard"
                                  label="Nom"
                                  InputLabelProps={{ shrink: true }}
                                  fullWidth
                                  name="nom"
                                  placeholder="Votre nom"
                                  value={formData.nom}
                                  onChange={handleChange}
                                  required
                                />
                              </Grid>
                              <Grid item xs={12} pr={1} mb={6}>
                                <MKInput
                                  variant="standard"
                                  label="Mail"
                                  placeholder="Votre adresse mail"
                                  InputLabelProps={{ shrink: true }}
                                  fullWidth
                                  type="email"
                                  name="email"
                                  value={formData.email}
                                  onChange={handleChange}
                                  required
                                />
                              </Grid>
                              <Grid item xs={12} pr={1} mb={6}>
                                <MKInput
                                  variant="outlined"
                                  label="Message"
                                  name="message"
                                  value={formData.message}
                                  onChange={handleChange}
                                  required
                                  fullWidth
                                  multiline
                                  rows={6}
                                />
                              </Grid>
                            </Grid>
                            <Grid
                              container
                              item
                              xs={12}
                              md={6}
                              justifyContent="flex-end"
                              textAlign="right"
                              ml="auto"
                            >
                              <MKButton variant="gradient" color="info" onClick={handleSubmit}>
                                Envoyé
                              </MKButton>
                            </Grid>
                          </MKBox>
                        </MKBox>
                      </Grid>
                    </Grid>

                  </MKBox>
                </Grid>
              </Container>
            </MKBox>


          </Grid>

        </Grid>
      </Container>
    </MKBox>
  );
}

export default Newsletter;
